import { collection, query } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { withIdConverter } from "@poseidon/firebase/converters/with-id";

export const useApplications = () => {
  const [applications, loading, error] = useCollectionData(
    query(collection(db, "applications")).withConverter(withIdConverter)
  );
  return { applications, loading, error };
};
